import React, { Component } from 'react'
import greenCheck from '../../../assets/images/green-check.svg'

import { Task, FraudCheck } from '../types'

export interface Props {
  task: Task
}

export default class Carfax extends Component<Props> {
  render() {
    const { task } = this.props
    const {
      inactive,
      vehicle,
      multipleRegistrations,
      nonPersonalOwnership,
      outOfAreaService,
    } = task.verifiables[0] as FraudCheck

    return (
      <div className="task-carfax">
        <div className="task-carfax__row">
          {vehicle && vehicle.healthReport && vehicle.healthReport.url ? (
            <a href={vehicle.healthReport.url} target="_blank">
              <h3 className="task-carfax__link">View the Carfax</h3>
            </a>
          ) : (
            <h3 className="task-carfax__link">No Carfax data</h3>
          )}
        </div>
        <div className="task-carfax__row">
          <div className="task-carfax__img">
            {inactive ? <img src={greenCheck} /> : null}
          </div>
          <div className="task-carfax__row--text">Inactive</div>
        </div>
        <div className="task-carfax__row">
          <div className="task-carfax__img">
            {multipleRegistrations ? <img src={greenCheck} /> : null}
          </div>
          <div className="task-carfax__row--text">Multiple registrations</div>
        </div>
        <div className="task-carfax__row">
          <div className="task-carfax__img">
            {nonPersonalOwnership ? <img src={greenCheck} /> : null}
          </div>
          <div className="task-carfax__row--text">Non-personal ownership</div>
        </div>
        <div className="task-carfax__row">
          <div className="task-carfax__img">
            {outOfAreaService ? <img src={greenCheck} /> : null}
          </div>
          <div className="task-carfax__row--text">Out of area service</div>
        </div>
      </div>
    )
  }
}
